let words = [
  "CONNECTION",
  "VOID",
  "PRELOAD",
  "TECHNICAL",
  "VARIANT",
  "MASTER",
  "CODE",
  "PHASE",
  "HUB",
];

let collo = [
  ["#807959", "#6375bf"],
  ["#bfaf60", "#765980"],
  ["#9c89ff", "#1a0974"],
  ["#29da6e", "#ff8c00"],
  ["#FF5C00", "#434343"],
  ["#C3C3A0", "#676767"],
  ["#29da6e", "#385ccb"],
  ["#29efc2", "#180a41", "#fb1053"],
];

const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const seed = urlParams.get("seed");
const play = urlParams.get("play");

let palette;
let mx, my;
let midX, midY;

let res1 = 0.01;
let res2 = 0.01;
let t = 0;

let sdOff = 99999;

function setup() {
  createCanvas(500, 500, SVG);
  angleMode(DEGREES);
  textAlign(CENTER);
  noLoop();
  colorMode(HSL);
  cursor(CROSS);

  textFont("Chakra Petch");

  mx = height / 2.5;
  my = width / 2.5;
  midX = width / 2;
  midY = height / 2;
}

function draw() {
  !play && randomSeed(seed + sdOff);

  palette = floor(random(collo.length));
  console.log(palette);

  let col = collo[palette][int(random(collo[palette].length))];

  background("#E9E9E9");

  bgCirc(random(width * 0.65, width * 0.8), col);

  frame();

  recta(10);
  tris(3);

  let xName = floor(random(1000));

  circo(6);

  werd(random(words), width / 60);
  werd(seed ? seed : xName, width / 60);

  t += 0.01;
}

function bgCirc(size, c) {
  var centerX = width / 2;
  var centerY = height / 2;

  push();
  noFill();

  stroke(c);
  // stroke(random(50), random(50), 80);

  strokeWeight(width * 0.001);
  ellipse(centerX, centerY, size);
  pop();
}

function tris(amount) {
  while (amount--) {
    let c = collo[palette][int(random(collo[palette].length))];
    push();
    let rr = random(2);
    if (rr > 1) {
      let grd = random(2);

      fill(c);
      grd > 1 && grad(midX, 0, midX, height, c, "#E9E9E9"); //  "#E9E9E9"

      noStroke();
    } else {
      noFill();
      stroke(c);
    }
    beginShape();
    vertex(random(midX - mx, midX + mx), random(midY - my, midY + my));
    vertex(random(midX - mx, midX + mx), random(midY - my, midY + my));
    vertex(random(midX - mx, midX + mx), random(midY - my, midY + my));
    endShape(CLOSE);
    pop();
  }
}

function recta(amount) {
  while (amount--) {
    push();
    let c = collo[palette][int(random(collo[palette].length))];

    let rr = random(2);
    if (rr > 1) {
      fill(c);
      grad(
        random(midX - mx, midX + mx),
        random(midY - my, midY + my),
        random(midX - mx, midX + mx),
        random(midY - my, midY + my),
        c,
        "#E9E9E9"
      );
      noStroke();
    } else {
      noFill();
      stroke(c);
    }

    strokeWeight(random(2));

    rect(
      random(midX - width / 4, midX + width / 4),
      random(midY - height / 4, midY + height / 4),
      random(10),
      random(10)
    );

    rect(
      random(midX - width / 4, midX + width / 4),
      random(midY - height / 4, midY + height / 4),
      random(30),
      random(30)
    );
    pop();
  }
}

function circo(amount) {
  while (amount--) {
    push();
    let c = collo[palette][int(random(collo[palette].length))];

    let rr = random(2);
    if (rr > 1) {
      fill(c);
      grad(
        random(midX - mx, midX + mx),
        random(midY - my, midY + my),
        random(midX - mx, midX + mx),
        random(midY - my, midY + my),
        c,
        "#E9E9E9"
      );
      noStroke();
    } else {
      noFill();
      stroke(c);
    }

    strokeWeight(random(2));

    ellipse(
      random(midX - mx, midX + mx),
      random(midY - my, midY + my),
      random(10)
    );
    ellipse(
      random(midX - mx, midX + mx),
      random(midY - my, midY + my),
      random(30)
    );
    pop();
  }
}

function werd(t, s) {
  noStroke();
  let c = collo[palette][int(random(collo[palette].length))];

  fill(c);
  textFont("Chakra Petch");
  textSize(random(s, s * 2));
  text(t, random(midX - mx, midX + mx), random(midY - my, midY + my));
}

function frame() {
  let inside = 20;
  noFill();
  stroke(0, 50, 100);
  strokeWeight(2);
  beginShape();
  vertex(inside, inside);
  vertex(width - inside, inside);
  vertex(width - inside, height - inside);
  vertex(inside, height - inside);
  endShape(CLOSE);
}

function debugBase64(base64URL) {
  var win = window.open();
  win.document.write(
    '<iframe src="' +
      base64URL +
      '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
  );
}

function getURI() {
  let el = document.getElementById("defaultCanvas0");
  const svg = el.getElementsByTagName("svg")[0];
  const encodedURI = "data:image/svg+xml;base64," + window.btoa(svg.outerHTML);
  // console.log(encodedURI);
  debugBase64(encodedURI);

  // let link = document.createElement("a");
  // link.href = encodedURI;
  // link.click();
}

function grad(x1, y1, x2, y2, c1, c2) {
  let grad = drawingContext.createLinearGradient(x1, y1, x2, y2);

  grad.addColorStop(0, c1);
  grad.addColorStop(1, c2);

  drawingContext.fillStyle = grad;
}

// function mousePressed() {
//   sdOff++;
//   draw();
// }

function keyTyped() {
  key === "s" && save("X-" + seed + ".png");
  key === "e" && save("X-" + seed + ".svg");
  key === "r" && getURI();
}
